@if (isLoggedIn()) {
    <div class="PGUserMenu" ngbDropdown [autoClose]="false" (openChange)="openChange.emit($event)">
        <button type="button" class="PGUserMenu-Button btn btn-white" ngbDropdownToggle
            [attr.aria-label]="'pg-user-menu.a11y.open' | locTranslate"
            [attr.aria-haspopup]="true"
            title="{{getUserName()}}">
            <i class="PGUserMenu-Button-MainIcon fa-regular fa-lg fa-user opacity-100 m-0" aria-hidden="true"></i>
            @if (registered) {
                <i class="PGUserMenu-Button-StatusIcon fa fa-circle opacity-100 m-0 {{getStatusColorClass(userStatus)}}" aria-hidden="true"></i>
            }
        </button>
        <div ngbDropdownMenu class="PGUserMenu-Menu">
            @if (isSwitchingLanguage || isSwitchingRealm) {
                <app-pg-loading></app-pg-loading>
            }
            @if (!isSwitchingLanguage && !isSwitchingRealm) {
                <div class="dropdown-item-text">
                    <div class="PGUserMenu-Profile">
                        <div>
                            <app-pg-user [user]="getUser()" [profile]="getProfile()" [vertical]="true"></app-pg-user>
                        </div>
                        <div>
                            <button type="button" class="btn btn-link btn-sm" (click)="requestEditProfile()"
                                [attr.aria-label]="'pg-user-menu.a11y.edit-profile' | locTranslate">
                                <i class="fa-regular fa-edit" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                </div>
                @if (registered) {
                    <div class="dropdown-divider"></div>
                    <div class="dropdown-item-text">
                        <b>{{ 'pg-user-menu.status' | locTranslate }}</b>
                    </div>
                    <div class="dropdown-item-text">
                        <app-pg-select #statusSelect [ariaLabel]="'pg-user-menu.status' | locTranslate" [required]="true" [ngModel]="userStatus" (ngModelChange)="setUserStatus($event)" [options]="statusOptions" display="oneLine"></app-pg-select>
                    </div>
                }
                <div class="dropdown-divider"></div>
                <div class="dropdown-item-text PGUserMenu-Menu-Item--Flex">
                    <b>{{ 'pg-user-menu.language' | locTranslate }}</b>
                </div>
                <div class="dropdown-item-text">
                    <app-pg-select [ariaLabel]="'pg-user-menu.language' | locTranslate" [required]="true" [ngModel]="getLanguage()" (ngModelChange)="setLanguage($event)" [options]="languageOptions" display="oneLine"></app-pg-select>
                </div>
                @if(isSuperAdmin()) {
                    <button type="button" class="dropdown-item d-flex justify-content-between" (click)="disableTranslationToggle();">
                        <div>{{ 'pg-user-menu.disable-translations' | locTranslate }}</div>
                        <div>
                            <app-pg-switch [small]="true" [ariaLabel]="'pg-user-menu.disable-translations' | locTranslate" [ngModel]="isTranslationDisabled()"></app-pg-switch>
                        </div>
                    </button>
                }
                @if (hasRealms || hasForceRealm) {
                    <div class="dropdown-divider"></div>
                    @if (hasForceRealm) {
                        <div class="dropdown-item-text">
                            <b>{{ 'pg-user-menu.realm' | locTranslate }}</b>
                        </div>
                        @if (getForceRealm(); as realm) {
                            <div class="dropdown-item-text PGUserMenu-Menu-Item--Flex">
                                <div>
                                    {{realm.name}}
                                </div>
                                @if (getForceRealmStatus() == 'pending') {
                                    <div class="text-end">
                                        <span class="badge bg-secondary">{{ 'pg-user-menu.realms-pending' | locTranslate }}</span>
                                    </div>
                                }
                            </div>
                        }
                    }
                    @if (!hasForceRealm && hasRealms) {
                        <div class="dropdown-item-text PGUserMenu-Menu-Item--Flex">
                            <b>{{ 'pg-user-menu.realms' | locTranslate }}</b>
                            <div class="PGUserMenu-Menu-Item-Button">
                                <button type="button" class="btn btn-link btn-sm" (click)="openAddRealm()"
                                    [attr.aria-label]="'pg-user-menu.a11y.add-realm' | locTranslate">
                                    <i class="fa-regular fa-castle" aria-hidden="true">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </i>
                                </button>
                            </div>
                        </div>
                        @if (getAvailableRealms() | customFn:sortRealms; as availableRealms) {
                            @for (realm of availableRealms; track realm) {
                                <button type="button" class="dropdown-item {{realm.id == getUserRealmId() ? 'active' : ''}}" (click)="setUserRealm(realm.id)">
                                    {{realm.name}}
                                </button>
                            }
                        }
                        @if (getPendingRealms() | customFn:sortRealms; as pendingRealms) {
                            @if (pendingRealms.length > 0) {
                                <div class="dropdown-item-text">
                                    <b>{{ 'pg-user-menu.realms-pending' | locTranslate }}</b>
                                </div>
                                @for (realm of pendingRealms; track realm) {
                                    <button type="button" class="dropdown-item {{realm.id == getUserRealmId() ? 'active' : ''}}" (click)="setUserRealm(realm.id)">
                                        {{realm.name}}
                                    </button>
                                }
                            }
                        }
                    }
                }
                @if (availableRoles.length > 0) {
                    <div class="dropdown-divider"></div>
                    <div class="dropdown-item-text">
                        <b>{{ 'pg-user-menu.roles' | locTranslate }}</b>
                    </div>
                    @for (role of availableRoles; track role) {
                        <button type="button" class="dropdown-item {{role.id == getUserRoleId() ? 'active' : ''}}" (click)="setUserRole(role.id)">
                            {{role.name}}
                        </button>
                    }
                }
                @if (getUserGroups(); as groups) {
                    <div class="dropdown-divider"></div>
                    <div class="dropdown-item-text">
                        <b>{{ 'pg-user-menu.groups' | locTranslate }}</b>
                    </div>
                    <div class="dropdown-item-text">
                        @if (groups.length == 0) {
                            <span class="text-muted">{{ 'pg-user-menu.groups-none' | locTranslate }}</span>
                        }
                        @for (group of groups; track group; let i = $index) {
                            @if (i > 0) {
                                ,
                                }{{group.label}}
                            }
                        </div>
                    }
                    @if (stripeAvailable) {
                        @if (getUserStripeId(); as stripe) {
                            <div class="dropdown-divider"></div>
                            <div class="dropdown-item-text">
                                <span>{{ 'pg-user-menu.stripe-connected' | locTranslate }}</span>
                                &nbsp;
                                <a target="_blank" href="https://dashboard.stripe.com/connect/accounts/overview">{{ 'pg-user-menu.stripe-connected-link' | locTranslate }}</a>
                            </div>
                        }
                        @if (!getUserStripeId()) {
                            <div class="dropdown-divider"></div>
                            <div class="dropdown-item-text pt-0 pb-0 d-flex justify-content-between align-items-center">
                                <span class="me-1">{{ 'pg-user-menu.stripe-not-connected' | locTranslate }}</span>
                                &nbsp;
                                <app-pg-stripe-connect [small]="true"></app-pg-stripe-connect>
                            </div>
                        }
                    }
                    <!-- TODO: verificare perché il menu sembra triggerare change di continuo -->
                    @if (menuElements != null) {
                        @for (group of menuElements; track group) {
                            <div class="dropdown-divider"></div>
                            @if (group.category != null) {
                                <div class="dropdown-item-text PGHeader-Menu-Content-Category">
                                    {{ group.category | locTranslate }}
                                </div>
                            }
                            @for (element of group.elements; track element) {
                                <div class="dropdown-item{{element.action == null ? '-text' : ''}}" (click)="onMenuElementClick(element)">
                                    {{ element.label | locTranslate }}
                                </div>
                            }
                        }
                    }

                    <div class="dropdown-divider"></div>
                    <button type="button" class="dropdown-item" (click)="openManageNotifications();">{{ 'pg-user-menu.manage-notifications' | locTranslate }}</button>
                    <button type="button" class="dropdown-item" (click)="changePassword();">{{ 'pg-user-menu.change-password' | locTranslate }}</button>
                    <button type="button" class="dropdown-item" (click)="doLogout();">{{ 'pg-user-menu.logout' | locTranslate }}</button>
                }
            </div>
            @if (showRealmsWarning) {
                <div class="alert alert-warning PGUserMenu-RealmsWarning pb-2 text-center" [appPgAnimations]="'EnterR'">
                    <div>
                        <div class="mb-2">
                            <i class="fa-regular fa-exclamation-triangle fa-lg"></i>
                        </div>
                        <div class="mb-3">
                            <div>{{ 'pg-user-menu.realms-warning-text' | locTranslate }}</div>
                            @if (!requiredRealms) {
                                <div>{{ 'pg-user-menu.realms-warning-text-later' | locTranslate }}</div>
                            }
                        </div>
                    </div>
                    <div class="d-flex justify-content-around border-top border-warning pt-2">
                        @if (!requiredRealms) {
                            <button class="btn btn-link text-muted" (click)="showRealmsWarning = false;">{{ 'pg-user-menu.realms-warning-button-later' | locTranslate }}</button>
                        }
                        <button class="btn btn-link" (click)="openAddRealm()">{{ 'pg-user-menu.realms-warning-button-request' | locTranslate }}</button>
                    </div>
                </div>
            }
        </div>
    }

<ng-template #modalAddRealm>
    @if (isRequestingAddRealm) {
        <app-pg-loading [isOverlay]="true"></app-pg-loading>
    }
    <div class="modal-header">
        <h5 class="modal-title">{{ 'pg-user-menu.modal-add-realm-title' | locTranslate }}</h5>
        <button type="button" class="modal-close btn btn-link" (click)="cancelAddRealm()">
            <i class="fa-regular fa-times"></i>
        </button>
    </div>
    <div class="modal-body">
        <div>
            @if (!hasUserSelectableRealms()) {
                {{ 'pg-user-menu.modal-add-realm-no-access' | locTranslate }}
            }

            @if (getAvailableRealms() | customFn:sortRealms; as availableRealms) {
                @if (availableRealms.length > 0) {
                    <div>
                        <b class="text-primary">{{ 'pg-user-menu.modal-add-realm-text-available-realms' | locTranslate }}</b>: @for (realm of availableRealms; track realm; let i = $index) {
                            <span>@if (i > 0) {, }{{realm.name}}</span>
                        }
                    </div>
                }
            }

            @if (getUnavailableRealms() | customFn:sortRealms; as unavailableRealms) {
                @if (unavailableRealms.length > 0) {
                    <div>
                        <b class="text-danger">{{ 'pg-user-menu.modal-add-realm-text-unavailable-realms' | locTranslate }}</b>: @for (realm of unavailableRealms; track realm; let i = $index) {
                            <span>@if (i > 0) {, }{{realm.name}}</span>
                        }
                    </div>
                }
            }

            @if (getPendingRealms() | customFn:sortRealms; as pendingRealms) {
                @if (pendingRealms.length > 0) {
                    <div>
                        <b>{{ 'pg-user-menu.modal-add-realm-text-pending-realms' | locTranslate }}</b>: @for (realm of pendingRealms; track realm; let i = $index) {
                            <span>@if (i > 0) {, }{{realm.name}}</span>
                        }
                    </div>
                }
            }

            <hr/>

            <div class="mb-3 PGUserMenu-ModalAddRealm-Add">
                <div class="form-group mb-0">
                    <label><b>{{ 'pg-user-menu.modal-add-realm-request-access' | locTranslate }}</b></label>
                    <app-pg-select [(ngModel)]="editAddRealmValue" [options]="editAddRealmOptions" display="oneLine"></app-pg-select>
                </div>
                <div>
                    <button class="btn btn-primary ms-2" [disabled]="isRequestingAddRealm || !editAddRealmValue" (click)="requestAddRealm()">{{ 'pg-user-menu.modal-add-realm-button-request' | locTranslate }}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>
